module.exports = {
  '查看{n}条回复': '查看{n}条回复',
  '{n}的分享': '{n}的分享',
  '{n}的审批文件': '{n}的审批文件',
  '{n}的申请': '{n}的申请',
  '该文档大小超过{n}，为了提供稳定的预览体验，目前仅支持下载查看': '该文档大小超过{n}，为了提供稳定的预览体验，目前仅支持下载查看',
  '该文档大小超过{n}暂不支持在线预览': '该文档大小超过{n}暂不支持在线预览',
  '确认将{n}版本设为最新版本?': '确认将{n}版本设为最新版本?',
  '共{n}项': '共{n}项',
  /* file文件列表部分 */
  // 链接管理开始
  '已选中{len}项': '已选中{len}项',
  ' 由<span title="{n}" class="update-creator">{n}</span>创建': ' 由<span title="{n}" class="update-creator">{n}</span>创建',
  '验证码已发送至手机，您还能发送{n}次验证码': '验证码已发送至手机，您还能发送{n}次验证码',

  // -----创建外链部分--------
  '距到期还有{d}天{h}时{m}分': '距到期还有{d}天{h}时{m}分',
  // 文件保护状态
  '本地打开、更新版本、移动等操作可能受限。':'本地打开、更新版本、移动等操作可能受限。',
  '联系所有者 {t} 在zDocs中关闭"<strong>跟踪更改</strong>"可恢复非保护状态。': '联系所有者 {t} 在zDocs中关闭"<strong>跟踪更改</strong>"可恢复非保护状<br/>态。',
  '包含敏感信息，命中{n}策略': '包含敏感信息，命中{n}策略',
  '已选中{n}个文件/文件夹': '已选中{n}个文件/文件夹',
  '解压到云端的目录存在文件格式限制，解压成功{m}个文件，已自动过滤{n}个文件，如有疑问请联系系统管理员。请点击查看': '解压到云端的目录存在文件格式限制，解压成功{m}个文件，已自动过滤{n}个文件，如有疑问请联系系统管理员。请点击查看',
}
